import { Outlet } from 'react-router-dom';

export default function AuthLayout() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/logo.jpg" alt="CleanYarn" className="h-16 w-auto mx-auto mb-3" />
          <p className="text-sm text-gray-500">Laundry & Dry Cleaning Management</p>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
